import type { ComponentSchema } from "../../../../../schema-types"
import { SUPPORTED_PAGES, LINK_ITEM_SCHEMA } from '../../_builder-constants'

export const schema: ComponentSchema = {
  type: 'footer',
  label: 'Footer Configuration',
  description: 'Site footer and utility links.',
  supportedPages: [...SUPPORTED_PAGES],
  variants: [{ id: 'v1', label: 'V1 (Neon Minimalist)' }],
  commonFields: [
    { key: 'title', label: 'About Title', type: 'string' },
    { key: 'logo', label: 'Logo', type: 'image' },
    { key: 'description', label: 'About Description', type: 'text' },
    { key: 'copyright', label: 'Copyright Text', type: 'string' },
    {
      key: 'columns',
      label: 'Footer Columns',
      type: 'array',
      itemSchema: [
        { key: 'title', label: 'Column Title', type: 'string' },
        { key: 'links', label: 'Links', type: 'array', itemSchema: LINK_ITEM_SCHEMA },
      ],
    },
    {
      key: 'socialLinks',
      label: 'Social Links',
      type: 'array',
      itemSchema: [
        {
          key: 'platform',
          label: 'Platform',
          type: 'select',
          options: [
            { label: 'Facebook', value: 'facebook' },
            { label: 'Instagram', value: 'instagram' },
            { label: 'Twitter', value: 'twitter' },
            { label: 'YouTube', value: 'youtube' },
            { label: 'LinkedIn', value: 'linkedin' },
          ],
        },
        { key: 'href', label: 'Link', type: 'string' },
      ],
    },
    { key: 'contactAddress', label: 'Contact Address', type: 'string' },
    { key: 'contactPhone', label: 'Contact Phone', type: 'string' },
    { key: 'contactEmail', label: 'Contact Email', type: 'string' },
    {
      key: 'paymentMethods',
      label: 'Payment Methods',
      type: 'array',
      itemSchema: [
        {
          key: 'platform',
          label: 'Platform',
          type: 'select',
          options: [
            { label: 'bKash', value: 'bkash' },
            { label: 'Nagad', value: 'nagad' },
            { label: 'Rocket', value: 'rocket' },
            { label: 'Upay', value: 'upay' },
            { label: 'Visa', value: 'visa' },
            { label: 'MasterCard', value: 'mastercard' },
            { label: 'Amex', value: 'amex' },
          ],
        },
        { key: 'icon', label: 'Custom Icon URL', type: 'image' },
      ],
    },
  ],
}
